import { useEffect } from 'react';

const upsertMeta = (name, content, attribute = 'name') => {
  if (!content) {
    return;
  }

  let element = document.head.querySelector(`meta[${attribute}="${name}"]`);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
};

const SEO = ({ title, description, keywords }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    upsertMeta('description', description);
    upsertMeta('keywords', keywords);
    upsertMeta('og:title', title, 'property');
    upsertMeta('og:description', description, 'property');
  }, [title, description, keywords]);

  return null;
};

export default SEO;
